<template>
  <div>
    <v-row v-if="!isViewMode">
      <v-col
        cols="12"
        class="lawsuitRequests"
      >
        <naj-data-table
          :headers="headers"
          :loading="loading"
          :items="lawsuitRequests"
          :disable-items-per-page="true"
          :title="local.caseRelatedRequest.incidentalRequest.requests"
          no-margin-bottom
        >
          <template slot-scope="{item}">
            <v-icon
              v-if="!isViewMode && isFinancialItem(item)"
              color="primary"
              @click="showEditDataModal(item, true)"
            >
              mdi-lead-pencil
            </v-icon>
            <v-icon
              color="primary"
              @click="selectViewItem(item, false)"
            >
              mdi-eye
            </v-icon>
            <v-icon
              v-if="!isViewMode && isFinancialItem(item)"
              color="red"
              @click="removeItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </naj-data-table>
      </v-col>
    </v-row>
    <v-row v-if="!isViewMode && isAddAvailable">
      <v-col
        cols="1"
        class="mb-6"
      >
        <naj-button
          icon="mdi-plus"
          @click="showAddDataModal"
        >
        </naj-button>
      </v-col>
    </v-row>
    <v-row v-if="isViewMode">
      <v-col cols="12">
        <naj-data-table
          :headers="headers"
          :loading="loading"
          :items="lawsuitRequests"
          :disable-items-per-page="true"
          :title="local.caseRelatedRequest.incidentalRequest.requests"
          no-margin-bottom
        >
          <template slot-scope="{item}">
            <v-icon
              color="primary"
              @click="selectViewItem(item, false)"
            >
              mdi-eye
            </v-icon>
          </template>
        </naj-data-table>
      </v-col>
    </v-row>
    <naj-modal
      ref="addDataModal"
      :title="local.dynamicFormAdmin.requestsForm.requests"
      :close-button="true"
      show-footer-close-button
      :width="1200"
      class="validation-form-modal"
      @onClose="onCloseAddDataModal"
    >
      <v-form
        ref="requestFormRef"
        @submit.prevent="submitData"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.dynamicFormAdmin.requestsForm.requestsList"
          :value.sync="requestForm.requestTypeId"
          :value-name.sync="requestForm.name"
          :items="filteredRequest"
          item-text="requestTypeName"
          item-value="requestTypeId"
          validates="required"
          :disabled="isRequestsSelectable"
          @change="requestsChanged"
        ></naj-input>
        <template v-if="loading">
          <naj-loader></naj-loader>
        </template>
        <template v-if="dynamicForm">
          <naj-dynamic-form
            :form-model="requestForm"
            :form-fields="dynamicForm.fields"
            :root-form-model="formModel"
            :custom-component-name="dynamicForm.customComponentName"
            :required-data="requiredData"
            :view-mode="isRequestFormInViewMode"
          ></naj-dynamic-form>
          <naj-input
            :type-id="formFieldType.textarea"
            :label="local.dynamicFormAdmin.requestsForm.requestTemplate"
            :value="requestForm.requestTemplate"
            :disabled="isRequestFormInViewMode"
            validates="max:5000|allowed_special_character"
            readonly
          ></naj-input>
        </template>
      </v-form>
      <template
        v-if="!isRequestFormInViewMode"
        slot="actions"
      >
        <naj-button
          :disabled="!requestForm.requestTypeId || loading"
          @click="submitData"
        >
          {{ requestFormSubmitText }}
        </naj-button>
      </template>
    </naj-modal>
    <naj-confirmation
      :show-modal="showRemovePopup"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.common.removeConfirmationMessage"
      :ok-btn-label="local.common.remove"
      @ok="removeConfirmed"
      @cancel="showRemovePopup = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import { mode, casePartyRoleEnum, partyTypeEnum, actionType, incidentalRequestsRequestTypeText, incidentalRequestsRequestStatusEnum, incidentalRequestsRequestStatusText } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
import { uuidGenerator } from '@/helpers/utils';
const initRequestForm = () => ({
  id: null,
  name: null,
  formId: null,
  formName: null,
  lawsuitRequestType: null,
  isFinancial: null,
  repeatable: false,
  objectKey: uuidGenerator(),
});
export default {
  name: 'IncidentalRequest',
  inject: ['$validator'],
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dynamicForm: {},
      caseData: {},
      caseParties: [],
      isRequestFormInViewMode: null,
      caseInfo: {},
      showRemovePopup: false,
      selectedItemToDelete: null,
      requestForm: initRequestForm(),
      requestFormViewMode: false,
      modifiedLawsuitRequests: [],
      defendants: [],
      isLoggedInUserExistsAsCaseParty: false,
      userCasePartyRoleInCase: {},
      isLoggedInUserCasePartyDefendant: false,
      unChangedLawsuitRequests: [],
      lawsuitRequests: [],
      requestsList: [],
      filteredRequest: [],
      requestFormSubmitText: '',
      actionTypeId: null,
      isAddAvailable: true,
      isRequestsSelectable: null,
      requestTitle: this.local.caseRelatedRequest.incidentalRequest.title,
      headers: [
        {
          value: 'name',
          text: this.local.caseRelatedRequest.incidentalRequest.requestsList,
        },
        {
          value: 'lawsuitRequestType',
          text: this.local.caseRelatedRequest.incidentalRequest.lawsuitRequestType,
        },
        // {
        //   value: 'lawsuitRequestStatus',
        //   text: this.local.caseRelatedRequest.incidentalRequest.lawsuitRequestStatus,
        // },
        {
          value: 'action',
          text: '',
        },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    actionTypes() {
      return this.actionTypeId;
    },
    prosecutorsCaseParties() {
      return (this.caseParties || []).filter(cp => cp.casePartyRole == casePartyRoleEnum.prosecutor);
    },
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
    casePartiesSelectboxDisabled() {
      return this.isViewMode || (this.formModel.applicantCasePartyId && this.isLoggedInUserExistsAsCaseParty);
    },
  },
  watch: {
    requestForm: {
      handler() {
        this.$set(this.requestForm, 'requestTemplate', this.handlebars(this.requestForm.template, this.requestForm));
      },
      deep: true,
    },
  },
  mounted() {
    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };
    Promise.all([
      this.getCaseRequestApplicants(params),
      this.getUserCasePartyRoleInCase(params),
    ])
      .then((res) => {
        this.caseParties = !this.isViewMode ? res[0].data.requestApplicants : [...res[0].data.prosecutors, ...res[0].data.defendants];
        this.defendants = res[0].data.defendants;
        this.userCasePartyRoleInCase = res[1].data;
        this.checkIfUserIsCasePartyProsecutor(); // get the original case party and check if he/she is prosecutor or not
        this.setRelatedPartyAsRequestApplicant();
        this.showCaseLawsuitRequests();
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    ...mapActions([
      'getCaseRequestApplicants',
      'getUserCasePartyRoleInCase',
      'getCaseLawsuitRequests',
      'getCaseDetails',
      'getCaseTypeRequestTypes',
    ]),
    ...mapGlobalActions(['getDynamicForm']),
    viewdRequests() {
      var requests = [];
      var dynamicData = this.formModel.dynamicData;
      dynamicData.modifiedLawsuitRequests.filter(x => x.isDeleted === false).map(function (item) {
        requests.push({
          ...item.requestData,
          'objectKey': item.objectKey,
          'isNew': item.isNew,
          'isModifed': item.isModifed,
          'isDeleted': item.isDeleted,
          lawsuitRequestType: incidentalRequestsRequestTypeText[item.requestData.isFinancial],
        });
      });
      dynamicData.lawsuitRequests.map(function (item) {
        if (!dynamicData.modifiedLawsuitRequests.find(x => x.requestData.id == item.requestData.id)) {
          requests.push({
            ...item.requestData,
            'objectKey': item.objectKey,
            'isNew': false,
            'isModifed': false,
            'isDeleted': false,
            lawsuitRequestType: incidentalRequestsRequestTypeText[item.requestData.isFinancial],
          });
        }
      });
      this.lawsuitRequests = requests;
    },
    updateTemplates() {
      let demands = [];
      this.lawsuitRequests.map(function (item) {
        demands.push(item.requestTemplate);
      });
      this.caseInfo['modifiedCaseDemands'] = demands.join('\n');
      this.caseInfo['modifiedCaseSubject'] = this.caseInfo.caseSubject;
      this.caseInfo['modifiedLawsuitRequests'] = this.modifiedLawsuitRequests;
      this.caseInfo['lawsuitRequests'] = this.unChangedLawsuitRequests;
      this.$set(this.formModel, 'dynamicData', this.caseInfo);
    },
    requestsChanged(requestTypeId) {
      let formId = this.requestsList.find(x => x.requestTypeId === requestTypeId).formId;
      this.requestForm.template = this.requestsList.find(x => x.requestTypeId === requestTypeId).template;
      this.requestForm.repeatable = this.requestsList.find(x => x.requestTypeId === requestTypeId).repeatable;
      this.getForm(formId);
    },
    isEditRequest() {
      if (this.actionTypeId === actionType.addNew)
        return false;
      else if (this.actionTypeId === actionType.edit)
        return true;
    },
    getForm(formId, trial = 0) {
      if (!this.dynamicForm[formId]) {
        this.loading = true;
        this.getDynamicForm({
          formId: formId,
          withoutParse: true,
        })
          .then((form) => {
            this.dynamicForm = form;
            this.selectedFormId();
            this.loading = false;
          })
          .catch(() => {
            if (trial < 2)
              this.getForm(formId, trial + 1);
            else
              this.closeAddDataModal();
          });
      }
    },
    selectedFormId() {
      return this.selectedRequest && this.selectedRequest.formId;
    },
    selectedRequest() {
      return this.requestsList.find(item => item.requestTypeId == this.requestForm.id);
    },
    submitData() {
      this.$refs.requestFormRef.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            this.submitRequestForm();
            this.closeAddDataModal();
          }
        });
    },
    submitRequestForm() {
      let isEdit = this.isEditRequest();
      this.requestForm.lawsuitRequestType = incidentalRequestsRequestTypeText[this.requestsList.find(x => x.requestTypeId === this.requestForm.requestTypeId).isFinancial];
      this.requestForm.isFinancial = this.requestsList.find(x => x.requestTypeId === this.requestForm.requestTypeId).isFinancial;
      this.lawsuitRequests = isEdit
        ? this.lawsuitRequests.map(item => item.objectKey == this.requestForm.objectKey ? this.requestForm : item)
        : [...this.lawsuitRequests, this.requestForm];
      if (!isEdit) {
        this.requestForm.id = this.requestForm.requestTypeId;
        this.requestForm.formId = this.requestsList.find(x => x.requestTypeId === this.requestForm.requestTypeId).formId;
        this.requestForm.formName = this.requestsList.find(x => x.requestTypeId === this.requestForm.requestTypeId).formName;
      }
      if (this.modifiedLawsuitRequests.some(item => item.requestData.objectKey == this.requestForm.objectKey)) {
        this.$delete(this.modifiedLawsuitRequests, (this.modifiedLawsuitRequests || []).indexOf(this.modifiedLawsuitRequests.find(item => item.requestData.objectKey == this.requestForm.objectKey)));
        isEdit = false;
      }
      var originalRequest = this.unChangedLawsuitRequests.find(x => x.objectKey == this.requestForm.objectKey);
      var objectKey = null;
      if (originalRequest !== null && originalRequest !== undefined) {
        isEdit = true;
        objectKey = originalRequest.objectKey; //this.unChangedLawsuitRequests.find(x => x.requestData.requestTypeId == this.requestForm.requestTypeId).objectKey;
      }
      let request = isEdit
        ? this.lawsuitRequests.map(item => item.id == this.requestForm.id ? {
          objectKey: item.objectKey ?? objectKey,
          requestData: this.requestForm,
          isNew: false,
          isModifed: true,
          isDeleted: false,
        } : { id: 0 })
        : [{
          objectKey: uuidGenerator(),
          requestData: {
            ...this.requestForm,
            lawsuitRequestType: incidentalRequestsRequestTypeText[this.requestsList.find(x => x.requestTypeId === this.requestForm.requestTypeId).isFinancial],
            isFinancial: this.requestsList.find(x => x.requestTypeId === this.requestForm.requestTypeId).isFinancial,
          },
          isFinancial: this.requestsList.find(x => x.requestTypeId === this.requestForm.requestTypeId).isFinancial,
          isNew: true,
          isModifed: false,
          isDeleted: false,
        }];
      this.modifiedLawsuitRequests = [...this.modifiedLawsuitRequests, request.find(x => x.id !== 0)];
      this.isAddAvailable = this.getFilteredRequests().length > 0;
      this.updateTemplates();
    },
    closeAddDataModal() {
      this.$refs.addDataModal.close();
      this.onCloseAddDataModal();
    },
    onCloseAddDataModal() {
      this.selectedItemToDelete = null;
      this.actionTypeId = null;
      this.requestForm = initRequestForm();
      this.requestFormViewMode = false;
    },
    callGetCaseTypeRequestTypes() {
      this.loading = true;
      this.getCaseTypeRequestTypes(this.formModel.case.caseTypeId)
        .then((res) => {
          this.requestsList = res;
          this.isAddAvailable = this.getFilteredRequests().length > 0;
          this.unChangedLawsuitRequests = this.lawsuitRequests.map(x => ({
            objectKey: x.objectKey,
            requestData: {
              ...x.lrd,
              requestTypeId: x.requestTypeId,
              isFinancial: x.isFinancial,
              template: this.requestsList.find(r => r.requestTypeId == x.requestTypeId).template,
            },
          }));
          if (this.isViewMode)
            this.viewdRequests();
        })
        .finally(() => { this.loading = false; });
    },
    callGetCaseInfo() {
      this.loading = true;
      this.getCaseDetails(this.formModel.case.objectKey)
        .then((res) => {
          this.caseInfo['caseDemands'] = res.data.caseDemands;
          this.caseInfo['caseSubject'] = res.data.caseSubject;
          this.caseInfo['lawsuitRequests'] = this.unChangedLawsuitRequests;
          if (!this.isViewMode)
            this.$set(this.formModel, 'dynamicData', this.caseInfo);
        })
        .finally(() => { this.loading = false; });
    },
    onCloseModal() {
      this.$emit('onClose');
    },
    selectViewItem(item, type) {
      this.requestFormViewMode = true;
      this.showEditDataModal(item, type);
    },
    isFinancialItem(item) {
      return item.isFinancial;
    },
    showEditDataModal(item, type) {
      this.requestForm = { ...item };
      this.requestForm.template = item.template || this.requestsList.find(x => x.requestTypeId === item.requestTypeId).template;
      this.requestForm.id = parseInt(this.requestForm.id);
      this.actionTypeId = type ? actionType.edit : actionType.view;
      this.requestTitle = item.name;
      this.isRequestFormInViewMode = this.actionTypeId === actionType.view ? true : false;
      let formId = item.formId || this.requestsList.find(x => x.requestTypeId === item.requestTypeId).formId;
      this.isRequestsSelectable = true;
      this.getForm(formId);
      this.showAddDataModal();
    },
    removeItem(item) {
      this.showRemovePopup = true;
      this.selectedItemToDelete = item;
    },
    removeConfirmed() {
      var modifiedRequest = this.modifiedLawsuitRequests.find(x => x.requestData.objectKey == this.selectedItemToDelete.objectKey);
      var originalRequest = this.unChangedLawsuitRequests.find(x => x.objectKey == this.selectedItemToDelete.objectKey);
      if (modifiedRequest !== null && modifiedRequest !== undefined) {
        if (originalRequest === null || originalRequest === undefined) {
          this.$delete(this.modifiedLawsuitRequests, (this.modifiedLawsuitRequests || []).indexOf(this.modifiedLawsuitRequests.find(item => item.requestData.objectKey == this.selectedItemToDelete.objectKey)));
        }
        else {
          this.modifiedLawsuitRequests.find(x => x.requestData.objectKey == this.selectedItemToDelete.objectKey).isNew = false;
          this.modifiedLawsuitRequests.find(x => x.requestData.objectKey == this.selectedItemToDelete.objectKey).isModifed = false;
          this.modifiedLawsuitRequests.find(x => x.requestData.objectKey == this.selectedItemToDelete.objectKey).isDeleted = true;
          this.modifiedLawsuitRequests.find(x => x.requestData.objectKey == this.selectedItemToDelete.objectKey).requestData = originalRequest.requestData;
        }
      }
      else {
        this.modifiedLawsuitRequests = [...this.modifiedLawsuitRequests, {
          objectKey: this.selectedItemToDelete.objectKey,
          requestData: this.selectedItemToDelete,
          isNew: false,
          isModifed: false,
          isDeleted: true,
        }];
      }
      const requestIndex = (this.lawsuitRequests || []).indexOf(this.selectedItemToDelete);
      this.$delete(this.lawsuitRequests, requestIndex);
      this.updateTemplates();
      this.selectedItemToDelete = null;
      this.isAddAvailable = this.getFilteredRequests().length > 0;
      this.showRemovePopup = false;
    },
    showCaseLawsuitRequests() {
      this.loading = true;
      const params = {
        isPega: this.formModel.isPega,
        objectKey: this.formModel.case.objectKey,
      };

      this.getCaseLawsuitRequests(params)
        .then((result) => {
          if (!this.isViewMode) {
            this.lawsuitRequests = result.data.map(x => ({
              ...JSON.parse(x.requestData || '{}'),
              requestId: x.id,
              caseLifeTimeId: x.caseLifeTimeId,
              requestTypeId: x.requestTypeId,
              amount: x.amount,
              lrd: JSON.parse(x.requestData || '{}'),
              objectKey: x.objectKey,
              isFinancial: x.isFinancial,
              lawsuitRequestType: incidentalRequestsRequestTypeText[x.isFinancial],
            }));
          }
          this.callGetCaseInfo();
          this.callGetCaseTypeRequestTypes();
        }).finally(() => (this.loading = false));
    },
    setRelatedPartyAsRequestApplicant() {
      const selectedParty = this.prosecutorsCaseParties.find(cp => cp.partyId == this.userCasePartyRoleInCase.partyId);
      if (selectedParty) {
        this.isLoggedInUserExistsAsCaseParty = true;
        this.$set(this.formModel, 'applicantCasePartyId', this.formModel.applicantCasePartyId || selectedParty.casePartyId);
      }
    },
    checkIfUserIsCasePartyProsecutor() {
      if (this.userCasePartyRoleInCase.roleInCaseId == casePartyRoleEnum.prosecutor) {
        this.isLoggedInUserCasePartyDefendant = false;
      } else if (this.userCasePartyRoleInCase.roleInCaseId == casePartyRoleEnum.defendant) {
        this.isLoggedInUserCasePartyDefendant = true;
      } else {
        // case party is agent or representative
        let basicCasePartyRoles = [casePartyRoleEnum.prosecutor, casePartyRoleEnum.defendant];
        let currentUserCaseParties = this.caseParties.filter(cp => cp.partyId == this.userCasePartyRoleInCase.partyId
          && !basicCasePartyRoles.some(b => b == cp.casePartyRole) && !!cp.relatedCasePartyID);

        for (const item of currentUserCaseParties) {
          var relatedCaseParty = this.getBasicCaseParty(item.relatedCasePartyID);
          if (relatedCaseParty && relatedCaseParty.casePartyRole == casePartyRoleEnum.defendant) {
            this.isLoggedInUserCasePartyDefendant = true;
          }
        }
      }
    },
    getBasicCaseParty(relatedCasePartyId) {
      var basicCaseParty = this.caseParties.find(b => b.casePartyId == relatedCasePartyId);
      let basicCasePartyRoles = [casePartyRoleEnum.prosecutor, casePartyRoleEnum.defendant];
      if (!basicCaseParty) {
        return null;
      }
      if (basicCaseParty && basicCaseParty.partyType == partyTypeEnum.person && basicCasePartyRoles.some(b => b == basicCaseParty.casePartyRole)) {
        return basicCaseParty;
      } else if (basicCaseParty.partyType != partyTypeEnum.person) {
        return basicCaseParty;
      } else
        return this.getBasicCaseParty(basicCaseParty.relatedCasePartyID);
    },
    getRequestFormSubmitText() {
      return this.actionTypeId === actionType.edit
        ? this.local.common.update
        : this.local.common.add;
    },
    getFilteredRequests() {
      let fRequest = [];
      let requets = this.lawsuitRequests.filter((elem) => {
        return this.requestsList.some((ele) => {
          return ele.requestTypeId === elem.requestTypeId;
        });
      });
      this.requestsList.map(function (item) {
        const requestExists = requets.find(x => x.requestTypeId === item.requestTypeId);
        if ((!requestExists || (requestExists && item.repeatable)) && item.isFinancial) {
          fRequest.push(item);
        }
      });
      return fRequest;
    },
    showAddDataModal() {
      if (!this.actionTypeId) {
        this.actionTypeId = actionType.addNew;
        this.isRequestFormInViewMode = false;
        this.isRequestsSelectable = false;
        this.filteredRequest = this.getFilteredRequests();
      }
      else {
        this.filteredRequest = this.requestsList;
      }
      this.requestFormSubmitText = this.getRequestFormSubmitText();
      this.dynamicForm = {};
      this.$refs.addDataModal.show();
    },
  },
};
</script>
<style lang="scss">
.lawsuitRequests table th span {
  font-size: 18px;
  font-weight: bold;
}
</style>